import React from 'react';
import SubmitButton from "v4/components/ui/SubmitButton/SubmitButton";
import {useFormRenderContext} from "v4/components/form/FormRender/context/FormRenderContext";
import {useFormState} from "react-hook-form";

export default function FormSubmitButton(props) {
    const {formRenderMethods} = useFormRenderContext();
    const {isValid} = useFormState({control: formRenderMethods.control});

    return (
        <SubmitButton {...props} isDisabled={props.isDisabled || !isValid}>
            {props.children}
        </SubmitButton>
    )
}
